(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('MyTemplatesController', MyTemplatesController);

		MyTemplatesController.$inject = ['$scope','CompanyReportService','$window','$state','$filter','$uibModal','$timeout', 'Principal'];
        //'GenericService', 'GenericServiceNew', 'CompanyReportService', '$http','$timeout', '$state', '$uibModal', '$filter', '$window', '$sce'
        //GenericService, GenericServiceNew, CompanyReportService, $http,$timeout, $state, $uibModal, $filter, $window, $sce
    function MyTemplatesController($scope,CompanyReportService,$window,$state,$filter,$uibModal,$timeout, Principal) {

        var userGrid = '';
        this.data = [];
        $scope.templateList = [];
        $scope.templateFilterList = [];
        $scope.uniqueCreatedByNames = [];
    	$scope.createddateflag = false;
		$scope.updatedddateflag = false;
        Principal.identity().then(function(account) {
			$scope.login = account.login;
        });
          
        $scope.generatedata = function(){
            CompanyReportService.getCompanyReportTemplates([]).then(
                function(successData){
                	 $scope.templateFilterList = successData.custom;
                    for (var i in successData.custom) {
                        for(var property in successData.custom[i]){
                        if(property == 'createdOn'){
                            successData.custom[i].createdOn = $filter('date')(successData.custom[i][property],'dd-MMM-yyyy');
                        }
                        if(property == 'lastUpdatedOn'){
                            if(successData.custom[i].lastUpdatedOn != undefined){
                                successData.custom[i].lastUpdatedOn = $filter('date')(successData.custom[i][property],'dd-MMM-yyyy');
                            }
                        }
                        if(property == 'templateJson'){
                            var templatejson = JSON.parse(successData.custom[i][property]);
                            if(templatejson.template.selectedSector == 'G'){
                                successData.custom[i].sector = 'Generic';
                            }
                            if(templatejson.template.selectedSector == 'M'){
                                successData.custom[i].sector = 'Manufacturing';
                            }
                            if(templatejson.template.selectedSector == 'F'){
                                successData.custom[i].sector = 'Financial';
                            }
                         }
                        }
                      }
                    $scope.templateList = successData.custom;
                    $scope.uniqueCreatedByNames = _.uniqBy($scope.templateFilterList, 'createBy');
                    $scope.uploadedDataList = {
                        dataProvider : successData.custom,
                        delegate : $scope
                    };
                     
    
                },function(errorData){
    
                }
            )  
        }

       

        $window.deleteCompany = function(item) {
            var itemObj = item.parentNode.component.data;
            $scope.selectedItemdata = item.parentNode.component.data;
            var modal = $uibModal
            .open({
                templateUrl : 'app/companyReport/customTemplate/delete-template.html',
                scope : $scope,
                backdrop : 'static'
            });
            $scope.modalInstancepeer = modal;
            $scope.clear = function() {
                $scope.modalInstancepeer.dismiss('cancel');
            }
            $scope.confirmDelete = function() {
                   
                CompanyReportService
                        .deletetemplate($scope.selectedItemdata.templateJson)
                        .then(function(response) {
                            console.log(response);
                            $scope.message = response.data;
                            $scope.ifsuccess = true;
                            $timeout(function () {
                                $scope.message = '';
                                $scope.ifsuccess = false;
                            }, 5000);
                            $scope.modalInstancepeer.dismiss(true);
                            $scope.uploadedlistcreation();
                            $scope.iferror = false;
                        }, function(error) {
                            $scope.modalInstancepeer.dismiss(true);
                            $scope.message = error.data;
                            $scope.iferror = true;
                            $timeout(function () {
                                $scope.message = '';
                                $scope.iferror = false;
                            }, 5000);
                        });
                    console.log("selectedItemdata is" +  $scope.selectedItemdata);
                }
            
            }

            
        $window.editTemplate = function(item) {
            $scope.selectedItemdata = item.parentNode.component.data;
            $state.go('createnewtemplate', {
                templateJson: JSON.parse($scope.selectedItemdata.templateJson),
                createdOn : $scope.selectedItemdata.createdOn,
                action:'edit'
            })
        }

        $window.viewTemplate = function(item) {
            $scope.selectedItemdata = item.parentNode.component.data;
            $state.go('createnewtemplate', {
                templateJson: JSON.parse($scope.selectedItemdata.templateJson),
                createdOn : $scope.selectedItemdata.createdOn,
                action: 'view'
            })

        }

        $scope.openCompany = function(rowData, column) {
            if(($scope.login == rowData.updatedBy || rowData.updatedBy == null) && $scope.login == rowData.createBy && rowData.assignedBy == null) {
                return '<span class="View" onClick= "viewTemplate(this)"><i class="fa fa-eye hover font-size-14 padding-10-10" title="View" ></i> </span><span class="load" onClick= "editTemplate(this)"><i class="fa fa-pencil-square-o hover upload-color font-size-14 padding-10-10" title="Load" ></i> </span>     <span class="delete" onClick= "deleteCompany(this)"><i class="fa fa-trash-o padding-10-10 hover remove-color font-size-15" title="delete"></i> </span>';
            } else {
                return '<span class="View" onClick= "viewTemplate(this)"><i class="fa fa-eye hover font-size-14 padding-10-10" title="View" ></i> </span>';
            }
        }

        $scope.uploadedlistcreation = function(event) {
            $scope.generatedata();
            userGrid = event.target;
            userGrid.validateNow();
        }

		$scope.popup3 = {
				opened : false
			};
			$scope.popup4 = {
				opened : false
			};
			$scope.open3 = function($event) {
				$scope.popup3.opened = true;
			};
			$scope.open4 = function($event) {
				$scope.popup4.opened = true;
			};
        
		$scope.applyFiltersModalForMyTemplate = function() {
			$uibModal.open({
				templateUrl: 'app/companyReport/customFilters/customMytemplateFilter.html',
				size: 'md',
				scope: $scope,
				controller: 'CustomMyTemplateFilterController'
			})
		}

		$scope.applyFiltersOnMyTemplate = function() {
			if(!$scope.createddateflag){
				$scope.filters.fromDate = null;
				$scope.filters.toDate = null;
			}
			
			if(!$scope.updatedddateflag){
				$scope.filters.fromupdatedDate = null;
				$scope.filters.toupdatedDate = null;
			}
			
			CompanyReportService.applyFiltersMytemplate($scope.filters).then(function(successData) {
				
		        for (var i in successData.custom) {
                    for(var property in successData.custom[i]){
                    if(property == 'createdOn'){
                        successData.custom[i].createdOn = $filter('date')(successData.custom[i][property],'dd-MMM-yyyy');
                    }
                    if(property == 'lastUpdatedOn'){
                        if(successData.custom[i].lastUpdatedOn != undefined){
                            successData.custom[i].lastUpdatedOn = $filter('date')(successData.custom[i][property],'dd-MMM-yyyy');
                        }
                    }
                    if(property == 'templateJson'){
                        var templatejson = JSON.parse(successData.custom[i][property]);
                        if(templatejson.template.selectedSector == 'G'){
                            successData.custom[i].sector = 'Generic';
                        }
                        if(templatejson.template.selectedSector == 'M'){
                            successData.custom[i].sector = 'Manufacturing';
                        }
                        if(templatejson.template.selectedSector == 'F'){
                            successData.custom[i].sector = 'Financial';
                        }
                     }
                    }
                  }
				$scope.uploadedDataList = {
                        dataProvider : successData.custom,
                        delegate : $scope
                    };
			}, function(error) {});
		}
        
        
	       $scope.filters = {
	    		   selectedTemplateNames: [],
	    		   createdBy: [],
	               fromDate: '',
	   			toDate: '',
	   		 fromupdatedDate: '',
	   			toupdatedDate: ''
	   		};
	   		$scope.fromDate = new Date();
	   		$scope.toDate = new Date();
			$scope.fromupdatedDate = new Date();
			$scope.toupdatedDate = new Date();
	   		$scope.usageTrackerGrid = '';
	   		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
	   				'shortDate', 'dd-MMM-yyyy' ];

	   		$scope.format = $scope.formats[0];
	           $scope.requiredFormat = $scope.formats[4];
	   		
	   		$scope.resetFilters = function() {
	   			$scope.restFilter();
	   		    $scope.generatedata();
	   		}
		
	        $scope.restFilter = function() {
	        	
	    		$scope.createddateflag = false;
				$scope.updatedddateflag = false;
//				var d = new Date(); 
//				d.setMonth(d.getMonth() - 6);
//				$scope.filters.fromDate = d;
//				$scope.filters.toDate = new Date();
//				$scope.fromDate = d;
//				$scope.toDate = new Date();
//				
//				var d = new Date(); 
//				d.setMonth(d.getMonth() - 6);
//				$scope.filters.fromupdatedDate = d;
//				$scope.filters.toupdatedDate = new Date();
//				$scope.fromupdatedDate = d;
//				$scope.toupdatedDate = new Date();
				
				$scope.filters.fromDate = null;
				$scope.filters.toDate = null;
				$scope.filters.fromupdatedDate = null;
				$scope.filters.toupdatedDate = null;
				$scope.filters.selectedTemplateNames = [];
				$scope.filters.createdBy = [];
				$scope.uniqueCreatedByNames = [];
			}
			$scope.restFilter();
	
		$scope.createdDate = function(){
//			if(!$scope.createddateflag){
//				var d = new Date(); 
//				d.setMonth(d.getMonth() - 6);
//				$scope.filters.fromDate = d;
//				$scope.filters.toDate = new Date();
//				$scope.fromDate = d;
//				$scope.toDate = new Date();
//			}
			$scope.createddateflag = true;
		}
		
		$scope.updatedDate = function(){
//			if(!$scope.updatedddateflag){
//			var d = new Date(); 
//			d.setMonth(d.getMonth() - 6);
//			$scope.filters.fromupdatedDate = d;
//			$scope.filters.toupdatedDate = new Date();
//			$scope.fromupdatedDate = d;
//			$scope.toupdatedDate = new Date();
//			}
			$scope.updatedddateflag = true;
		}
	
        $scope.generatedata();
         
       
    }

        
      
})();